import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

import { NavDirectionProvider } from "./NavDirectionContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <NavDirectionProvider>
      <App />
    </NavDirectionProvider>
  </BrowserRouter>
);
